import React, { Component } from "react";
import { PageHeader, Modal } from "antd";
import { Tabs } from "antd5";
import { LoginOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import AparienciaLogin from "./AparienciaLogin/AparienciaLogin";

class AparienciasBiwo extends Component {
  state = {
    activeKey: "1",
  };

  loginRef = React.createRef();

  getRefByKey = (key) => {
    if (key === "1") return this.loginRef.current;
    return null;
  };

  onTabClick = (newKey) => {
    const { activeKey } = this.state;
    if (newKey === activeKey) return;

    const current = this.getRefByKey(activeKey);
    const hayCambios = current?.tieneCambios?.();

    if (hayCambios) {
      Modal.confirm({
        title: "Tienes cambios sin guardar",
        icon: <ExclamationCircleOutlined />,
        content: "¿Deseas guardar los cambios antes de cambiar de pestaña?",
        okText: "Guardar y Cambiar",
        cancelText: "Descartar",
        centered: true,
        onOk: () => {
          return current.guardarDesdePadre().then((exito) => {
            if (exito) this.setState({ activeKey: newKey });
          });
        },
        onCancel: () => {
          current?.descartarCambios?.();
          this.setState({ activeKey: newKey });
        },
      });
    } else {
      this.setState({ activeKey: newKey });
    }
  };

  render() {
    const { activeKey } = this.state;

    const tabItems = [
      {
        label: (
          <span>
            <LoginOutlined /> Login
          </span>
        ),
        key: "1",
        children: <AparienciaLogin ref={this.loginRef} />,
      },
      // Próximos tabs: Panel Principal, Correos, etc.
    ];

    return (
      <>
        <PageHeader
          title="Apariencias Biwo"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div
          style={{
            backgroundColor: "white",
            padding: 20,
            paddingTop: 5,
            borderRadius: 6,
          }}
        >
          <Tabs
            activeKey={activeKey}
            items={tabItems}
            onTabClick={this.onTabClick}
          />
        </div>
      </>
    );
  }
}

export default AparienciasBiwo;
